import { updateObject } from './../../utils/utility';
import deviceRecoveryServices from '../../libs/deviceRecovery-services';

const initialState = {
    token: null,
    tokenCallComplete: false,
    userInfoCallComplete: false,
    accessToken: "",
    email: "",
    givenName: "",
    familyName: "",
    id: "",
    userId: "",
    authSessionResponse: "",
    sessionId: null,
    siteUnderMaintenance: false,
    isHPEmployee: false,
    onlineStoreCustomer: false,
    priceListUploadId: "",
    captchaEnable: true,
    postChangedPasswordRequest: false,
    envType: "dev",
    userPreRegistrationResponse: null
};

const setAuthToken = (state = initialState, action) => {
    deviceRecoveryServices.defaults.headers.common['Authorization'] = "Bearer " + action.payload;
    return updateObject(state, {
        token: action.payload,
        tokenCallComplete: true
    });
}

const setAuthorizedUser = (state = initialState, action) => {
    const sessionId = action.data.sessionId || "";
    if (sessionId) {
        delete deviceRecoveryServices.defaults.headers.common['Authorization'];
        deviceRecoveryServices.defaults.headers.common['Authorization'] = "Bearer " + sessionId;
    }
    return updateObject(state, {
        email: action.data.email ? action.data.email : "",
        givenName: action.data.givenName ? action.data.givenName : "",
        familyName: action.data.familyName ? action.data.familyName : "",
        id: action.data.id ? action.data.id : "",
        userId: action.data.userId ? action.data.userId : "",
        accessToken: action.data.accessToken ? action.data.accessToken : "",
        authSessionResponse: action.data.authSessionResponse ? action.data.authSessionResponse : "",
        sessionId: sessionId,
        userInfoCallComplete: true,
        isHPEmployee: action.data.email ? (action.data.email.replace(/.*@/, "").split('.')[0]).toLowerCase() === "hp" : false,
        onlineStoreCustomer: action.data.onlineStoreCustomer && action.data.onlineStoreCustomer === "YES" ? true : false,
        priceListUploadId: action.data.priceListUploadId && action.data.priceListUploadId !== "null" ? action.data.priceListUploadId : "",
        captchaEnable: action.data.captchaEnabled && action.data.captchaEnabled,
        postChangedPasswordRequest: action.data.changedPassword ? true : false,
        userPreRegistrationResponse: action.data.userPreRegistrationResponse || null,
        contactNo: action.data.contactNo || ''
    });
}

const setTokenCallComplete = (state = initialState) => {
    return updateObject(state, {
        tokenCallComplete: true
    });
}

const setCaptchaEnable = (state = initialState, action) => {
    return updateObject(state, {
        captchaEnable: action.data
    });
}

const setPostChangedPasswordRequest = (state = initialState, action) => {
    return updateObject(state, {
        postChangedPasswordRequest: action.data
    });
}

const setUserInfoCallComplete = (state = initialState) => {
    return updateObject(state, {
        userInfoCallComplete: true
    });
}

const clearAuthSessionResponse = (state = initialState) => {
    return updateObject(state, {
        authSessionResponse: ""
    });
}

const setSiteUnderMaintenance = (state = initialState) => {
    return updateObject(state, {
        siteUnderMaintenance: true,
        userInfoCallComplete: true
    });
}

const resetAuthorizationContent = (state = initialState) => {
    return updateObject(state, { ...initialState });
}

const reducer = (state = initialState, action) => {
    if (action.type === "SET_AUTH_TOKEN") {
        return setAuthToken(state, action);
    }
    if (action.type === "SET_TOKEN_CALL_COMPLETE") {
        return setTokenCallComplete(state);
    }
    if (action.type === "SET_USER_INFO_CALL_COMPLETE") {
        return setUserInfoCallComplete(state);
    }
    if (action.type === "SET_AUTHORIZED_USER") {
        return setAuthorizedUser(state, action);
    }
    if (action.type === "CLEAR_AUTH_SESSION_RESPONSE") {
        return clearAuthSessionResponse(state);
    }
    if (action.type === "SET_SITE_UNDER_MAINTENANCE") {
        return setSiteUnderMaintenance(state);
    }
    if (action.type === "SET_CAPTCHA_ENABLE") {
        return setCaptchaEnable(state, action);
    }
    if (action.type === "SET_POST_CHANGED_PASSWORD_REQUEST") {
        return setPostChangedPasswordRequest(state, action);
    }
    if (action.type === "RESET_AUTHORIZATION_CONTENT") {
        return resetAuthorizationContent(state, action);
    }
    return state;
}

export default reducer;